/**
 * React Query key factory for the fraud-detector (contact background
 * verification) teammate.
 *
 * Relocated out of `pages/ats-job-creation/.../useFraudDetectorTeammate` so
 * component-layer code (e.g. background-check action helpers) can share the
 * cache keys without a components -> pages boundary violation.
 */
export const fraudDetectorTeammateKeys = {
  accountSettings: ['fraudDetector', 'settings'] as const,
  jobSettings: (jobId: string | number) =>
    ['fraudDetector', 'jobSettings', jobId] as const,
};
